import cookieBannerTemplate from './cookieBanner.html';

tnCookieBannerController.$inject = ['$localStorage'];
function tnCookieBannerController($localStorage) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.cookiesAccepted = $localStorage.cookiesAccepted;

    vm.accept = () => {
        $localStorage.cookiesAccepted = true;
        vm.cookiesAccepted = true;
    };
}

export function tnCookieBannerDirective() {
    return {
        scope: {},
        controller: tnCookieBannerController,
        controllerAs: 'vm',
        template: cookieBannerTemplate,
        link: (scope, el) => {
            el.on('wheel mousewheel touchmove', (event) => {
                event.preventDefault();
            });
        },
    };
}
